import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { ApiFreezeService } from '../services/api-freeze.service';

/**
 * Stops every request once the page has outlived its impersonation and its user chose to stay on
 * it: what it shows belongs to somebody else, and whatever it asked for now would not.
 */
@Injectable()
export class FrozenApiInterceptor implements HttpInterceptor {
  private readonly apiFreeze = inject(ApiFreezeService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return this.apiFreeze.isFrozen() ? EMPTY : next.handle(request);
  }
}
